/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import {
  CompanyContainer,
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';

import { Table, IconButton as IconButtonWithText, Loader } from '../../../Components/uielements';

import { AddPlusIcon } from '../../../Components/icons';

import { IntlMessages } from '../../../helper/langHelper';
import EnvdFormSelectModal from './modals/EnvdFormSelectModal';

const Envd = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [chooseEnvdForm, setChooseEnvdForm] = useState(false);

  const eNVDTableData = [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  //   table coulmns
  const eNVDColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'name',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
      },
      {
        Header: <IntlMessages id="table.col.date" />,
        accessor: 'date',
      },
      {
        Header: <IntlMessages id="table.col.zone" />,
        accessor: 'zone',
        width: '24%',
      },
      {
        Header: <IntlMessages id="table.col.location" />,
        accessor: 'location',
      },
      {
        Header: <IntlMessages id="table.col.emergency.email" />,
        accessor: 'emergencyEmail',
      },
      {
        Header: <IntlMessages id="table.col.emergency.number" />,
        accessor: 'emergencyNumber',
      },
    ],
    []
  );

  const handleClosed = () => {
    setChooseEnvdForm(false);
  };
  const handleOpen = () => {
    setChooseEnvdForm(true);
  };

  if (false) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }
  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.records.eNVD" />
        </HeaderTitle>
        <IconButtonWithText
          text={<IntlMessages id="button.text.createeNVD" />}
          icon={<AddPlusIcon />}
          onClick={handleOpen}
        />
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={eNVDTableData}
          columns={eNVDColumns}
          hasFooter={true}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={0}
        />
      </TableWrapper>
      <EnvdFormSelectModal onClose={handleClosed} isOpen={chooseEnvdForm} />
    </StyledContainer>
  );
};

export default Envd;
